import * as React from 'react';
import { Select } from 'antd';
import { observer } from 'mobx-react';
export const Coatings = observer((props) => {
    const items = props.coatings;
    // Get Custom Option
    const custom = items.find(item => item.name === 'Custom');
    const sortItems = items
        .slice()
        .sort(a => (a.name === 'None' ? -1 : 1))
        .sort(a => (a.name === 'Custom' ? -1 : 1));
    const menu = sortItems.map(item => {
        return React.createElement(Select.Option, { key: item.id }, item.name);
    });
    const EmptyTag = (React.createElement("div", { className: "flex flex-no-wrap p-2 cursor-pointer", onClick: () => {
            if (custom && props.onChange) {
                props.onChange({
                    key: custom.id.toString(),
                    label: custom.name,
                }, []);
            }
        } },
        React.createElement("span", { className: "flex flex-row items-center cursor-pointer justify-center" },
            "Can't find your Coating? please select ",
            React.createElement("div", { className: "ml-2 link" }, "Custom"))));
    return (React.createElement("div", null,
        React.createElement(Select, { showSearch: true, labelInValue: true, size: 'small', style: { width: '100%' }, dropdownMatchSelectWidth: false, placeholder: "Select", ...props, notFoundContent: EmptyTag, allowClear: true, filterOption: (input, option) => {
                try {
                    if (!option.key) {
                        // Filter by group label
                        return option.props?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                    }
                    return option.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                }
                catch (e) {
                    return false;
                }
            }, dropdownRender: menu => React.createElement("div", null, menu) },
            React.createElement(Select.OptGroup, { label: 'Options' }, menu))));
});
